<div [@WindowOpenClose]="windowVisible.getValue() ? 'visible' : 'invisible'" (click)="windowClick()">
    <dialog-header [label]="'SETTINGS.MAP_SETTINGS' | translate" [dialogRef]='dialogRef' [object]='this'></dialog-header>
    <mat-card class="display-settings">
    </mat-card>
</div>